<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="1150px"
    scrollable
    class="scrollDesign"
  >
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">
          {{ $t('students.import_students_and_tutors') }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-stepper v-model="step" class="elevation-0">
              <v-stepper-header>
                <v-stepper-step :complete="step > 1" :step="1">
                  {{ $t('students.massive_upload.steps.upload_your_file') }}
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="step > 2" :step="2">
                  <span v-if="!working.validating">{{ modal.text }}</span>
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="step > 3" :step="3">
                  <span v-if="!working.validating">
                    {{ $t('students.massive_upload.steps.validate_data') }}
                  </span>
                  <v-progress-circular
                    v-else
                    size="20"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :step="4">
                  {{ $t('students.massive_upload.steps.finished') }}
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <!-- Paso 1 "CARGA" -->
                <v-stepper-content :step="1">
                  <v-card>
                    <v-card-title class="subheading">
                      {{
                        $t('students.massive_upload.step_1.import_excel_file')
                      }}
                      <a href="examples/lista_ejemplo_alumnos_tutores.xlsx">
                        {{ $t('students.massive_upload.step_1.download') }}
                      </a>
                    </v-card-title>
                    <v-layout row wrap justify-center>
                      <v-flex
                        xs12
                        class="form-csv text-xs-center"
                        style="height: 35vh"
                      >
                        <input
                          @change="fileLoad($event)"
                          id="file_csv_colab"
                          type="file"
                          accept=".xlsx"
                        />
                        <div class="csv-text">
                          <h4 class="center-align">
                            {{
                              $t('students.massive_upload.step_1.drag_file_1')
                            }}
                          </h4>
                          <h5 id="csv-success">
                            {{
                              $t('students.massive_upload.step_1.drag_file_2')
                            }}
                            <u style="color: red">
                              <span style="color: red">
                                {{
                                  $t(
                                    'students.massive_upload.step_1.drag_file_3'
                                  )
                                }}
                              </span>
                            </u>
                            {{
                              $t('students.massive_upload.step_1.drag_file_4')
                            }}
                          </h5>
                        </div>
                      </v-flex>
                      <v-expand-transition>
                        <v-flex
                          v-show="working.loading"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </v-flex>
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-flex
                          v-show="flags.status == 200"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-icon style="vertical-align: bottom" color="green">
                            check
                          </v-icon>
                          {{ $t('students.massive_upload.step_1.valid_file') }}
                        </v-flex>
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-flex
                          v-show="flags.status == 201"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-icon style="vertical-align: bottom" color="orange">
                            warning
                          </v-icon>
                          Archivo con registros erróneos pero aún importable
                        </v-flex>
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-flex
                          v-show="flags.status == 404"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-icon style="vertical-align: bottom" color="red">
                            clear
                          </v-icon>
                          El archivo no es válido
                        </v-flex>
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-flex
                          v-show="flags.status == 403"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-icon style="vertical-align: bottom" color="red"
                            >clear</v-icon
                          >El formato del archivo no es correcto; descarga el
                          ejemplo para mayor información
                        </v-flex>
                      </v-expand-transition>
                    </v-layout>
                    <v-layout row wrap justify-center>
                      <v-flex xs12>
                        <v-checkbox
                          color="primary"
                          id="promote"
                          v-model="promote"
                          :label="
                            $t('students.massive_upload.step_1.update_levels')
                          "
                          hide-details
                        />
                        <v-checkbox
                          class="mb-3"
                          color="primary"
                          label="Eliminar alumnos que no se incluyan en el listado"
                          v-model="removeMissing"
                          @change="onChangeRemoveMissing"
                          hide-details
                        />
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-stepper-content>
                <!-- Paso 2 "MOSTRAR ERROR" -->
                <v-stepper-content :step="2">
                  <v-card>
                    <v-layout
                      v-if="flags.status === 404"
                      row
                      wrap
                      justify-center
                    >
                      <v-flex xs12 class="text-xs-center">
                        <v-alert
                          style="border-radius: 33px"
                          :value="true"
                          :type="'warning'"
                          >{{ modal.message }}</v-alert
                        >
                      </v-flex>
                    </v-layout>
                    <v-data-table
                      height="52vh"
                      :headers="headers"
                      :items="errorItems"
                      :expand="expand"
                      :loading="working.validating"
                      :rows-per-page-text="
                        $t(
                          'students.massive_upload.step_2.table.records_per_page'
                        )
                      "
                      :rows-per-page-items="[50, 100]"
                    >
                      <template v-slot:progress>
                        <v-progress-linear
                          color="primary"
                          indeterminate
                        ></v-progress-linear>
                      </template>
                      <template v-slot:pageText="props"
                        >{{ props.pageStart }} - {{ props.pageStop }} de
                        {{ props.itemsLength }}</template
                      >
                      <template v-slot:headers="props">
                        <tr>
                          <th
                            v-for="header of props.headers"
                            :key="header.text"
                          >
                            {{ $t(header.langKey) }}
                          </th>
                        </tr>
                      </template>
                      <template v-slot:items="props">
                        <td v-if="flags.status != 200">
                          <v-edit-dialog
                            :return-value.sync="props.item.Nombre"
                            lazy
                          >
                            {{ props.item.Nombre }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Nombre"
                                label="Nombre"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Nombre }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Apellidos"
                            lazy
                          >
                            {{ props.item.Apellidos }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Apellidos"
                                label="Apellidos"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Apellidos }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Genero"
                            lazy
                          >
                            {{ props.item.Genero }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Genero"
                                label="Género"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Genero }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Nivel"
                            lazy
                          >
                            {{ props.item.Nivel }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Nivel"
                                label="Nivel"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Nivel }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Grado"
                            lazy
                          >
                            {{ props.item.Grado }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Grado"
                                label="Grado"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Grado }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Grupo"
                            lazy
                          >
                            {{ props.item.Grupo }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Grupo"
                                label="Grupo"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Grupo }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Matricula"
                            lazy
                          >
                            {{ props.item.Matricula }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Matricula"
                                label="Matrícula"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Matricula }}</td>
                        <td>{{ props.item.Matricula_Nueva }}</td>
                        <td @click="props.expanded = !props.expanded">
                          <v-btn flat fab small>
                            <v-badge
                              :color="
                                props.item.parents.length ? 'green' : 'red'
                              "
                            >
                              <template v-slot:badge>
                                <span>{{ props.item.parents.length }}</span>
                              </template>
                              <v-icon class="no-border">
                                {{
                                  !props.item.parents.length
                                    ? 'person_outline'
                                    : props.item.parents.length == 1
                                    ? 'person'
                                    : 'group'
                                }}
                              </v-icon>
                            </v-badge>
                          </v-btn>
                        </td>
                        <td
                          v-if="excel2jsonFail.length > 0"
                          class="text-xs-right"
                        >
                          {{ props.item.Error }}
                        </td>
                        <td
                          v-if="excel2jsonFail.length > 0"
                          class="text-xs-right"
                        >
                          <v-btn flat fab @click="editStudent(props.item)">
                            <v-icon class="no-border">edit_note</v-icon>
                          </v-btn>
                        </td>
                        <td v-else></td>
                      </template>
                      <template v-slot:expand="props">
                        <ImportParentsDetails
                          :flags="flags"
                          :parents="props.item.parents"
                          @onTest="onTest1"
                        ></ImportParentsDetails>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-stepper-content>
                <!-- Paso 3 "COMPARACIÓN "-->
                <v-stepper-content :step="3">
                  <v-card>
                    <v-layout row wrap justify-center>
                      <div
                        style="
                          height: 28px;
                          width: 100%;
                          border: 1px solid #aaa;
                          border-radius: 13px;
                          padding: 3px;
                          text-align: -webkit-center;
                          color: white;
                        "
                      >
                        <div
                          class="bar"
                          :style="{
                            width: 4 + (progress * (100 - 4)) / 100 + '%',
                          }"
                        >
                          <span class="spb">{{ progress.toFixed(2) }}%</span>
                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <v-flex xs12 sm8>
                        <v-text-field
                          v-model="search"
                          :label="
                            $t('students.massive_upload.step_3.table.search')
                          "
                          outline
                          height="47px"
                        />
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-select
                          v-model="conbo"
                          :items="stdF"
                          :label="
                            $t(
                              'students.massive_upload.step_3.table.status_top'
                            )
                          "
                          outline
                          height="47px"
                        >
                        </v-select>
                      </v-flex>

                      <v-data-table
                        :search="search"
                        :headers="headers1"
                        :items="filteredItemsByStatus"
                        :expand="expand"
                        :loading="working.validating"
                        :custom-filter="customFilter"
                        :rows-per-page-text="
                          $t(
                            'students.massive_upload.step_3.table.records_per_page'
                          )
                        "
                        no-results-text="No se encontraron coincidencias"
                        :rows-per-page-items="[50, 100]"
                      >
                        <template v-slot:progress>
                          <v-progress-linear
                            color="primary"
                            indeterminate
                          ></v-progress-linear>
                        </template>
                        <template v-slot:pageText="props">
                          {{ props.pageStart }} - {{ props.pageStop }} de
                          {{ props.itemsLength }}
                        </template>
                        <template v-slot:headers="props">
                          <tr>
                            <th
                              v-for="header of props.headers"
                              :key="header.text"
                            >
                              {{ $t(header.langKey) }}
                            </th>
                          </tr>
                        </template>
                        <template v-slot:items="props">
                          <td>{{ props.item.firstName }}</td>

                          <td>{{ props.item.lastName }}</td>

                          <td v-if="props.item.gender == 'FEMALE'">Femenino</td>
                          <td v-else-if="props.item.gender == 'MALE'">
                            Masculino
                          </td>

                          <td>{{ props.item.level.typeLevel }}</td>

                          <td>{{ props.item.grade }}</td>

                          <td>{{ props.item.groupName }}</td>

                          <td
                            v-if="props.item.updatedPersonId"
                            style="color: orange"
                            class="text-xs"
                          >
                            <strong>{{ props.item.updatedPersonId }}</strong>
                          </td>
                          <td v-else>{{ props.item.personId }}</td>

                          <td @click="props.expanded = !props.expanded">
                            <v-btn flat fab small>
                              <v-badge
                                :color="
                                  props.item.parents.length ? 'green' : 'red'
                                "
                              >
                                <template v-slot:badge>
                                  <span>{{ props.item.parents.length }}</span>
                                </template>
                                <v-icon class="no-border">
                                  {{
                                    !props.item.parents.length
                                      ? 'person_outline'
                                      : props.item.parents.length == 1
                                      ? 'person'
                                      : 'group'
                                  }}
                                </v-icon>
                              </v-badge>
                            </v-btn>
                          </td>

                          <td
                            v-if="props.item.status == 'UPGRADE'"
                            style="color: orange"
                            class="text-xs"
                          >
                            <strong>Actualización</strong>
                          </td>
                          <td
                            v-if="props.item.status == 'NEW'"
                            style="color: green"
                            class="text-xs"
                          >
                            <strong>Alta</strong>
                          </td>
                          <td
                            v-if="props.item.status == 'REMOVE'"
                            style="color: red"
                            class="text-xs"
                          >
                            <strong>Baja</strong>
                          </td>
                          <td
                            v-if="props.item.status == 'UNCHANGED'"
                            class="text-xs"
                          >
                            <strong>Sin cambios</strong>
                          </td>

                          <v-btn flat fab @click="editStudent(props.item)">
                            <v-icon class="no-border">edit_note</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:expand="props">
                          <ImportParentsDetails
                            :flags="flags"
                            :parents="props.item.parents"
                            @parentUp="parentUp"
                          ></ImportParentsDetails>
                        </template>
                      </v-data-table>
                    </v-layout>
                  </v-card>
                </v-stepper-content>
                <!-- Paso 4 -->
                <v-stepper-content :step="4">
                  <v-card height="400px">
                    <v-layout row wrap justify-center>
                      <div
                        style="
                          height: 28px;
                          width: 100%;
                          border: 1px solid #aaa;
                          border-radius: 13px;
                          padding: 3px;
                          text-align: -webkit-center;
                          color: white;
                        "
                      >
                        <div
                          class="bar"
                          :style="{
                            width: 4 + (progressStd * (100 - 4)) / 100 + '%',
                          }"
                        >
                          <span class="spb">{{ progressStd.toFixed(2) }}%</span>
                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <v-flex xs12 class="text-xs-center">
                        <h1>{{ modal.title }}</h1>
                        <v-alert
                          style="border-radius: 33px"
                          :value="true"
                          v-if="working.alt"
                          :type="flags.status == 201 ? 'warning' : 'success'"
                        >
                          {{ modal.message }}
                        </v-alert>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
              <ConfirmMail
                :value="confirm.value"
                :title="confirm.title"
                :description="confirm.description"
                v-on:desition="desitionLink"
              ></ConfirmMail>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-card-text>
      <!-- Barra Inferior -->
      <v-card-actions>
        <v-btn
          v-if="noButtons && step != 4"
          :disabled="step == 1 || step == 3"
          color="primary"
          icon
          @click="back"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="noButtons && step < 4" flat small @click="close">
          {{ $t('students.massive_upload.cancel') }}
        </v-btn>
        <v-btn
          v-if="step == 4 && flags.status == 201"
          color="primary"
          @click="download"
        >
          {{ $t('students.massive_upload.download') }}
        </v-btn>
        <v-btn v-if="step == 4 && progressStd == 100" @click="close" flat>
          {{ $t('students.massive_upload.finish') }}
        </v-btn>
        <v-btn
          v-if="step == 2 && modal.text == 'Errores encontrados'"
          color="primary"
          small
          @click="next"
        >
          {{ $t('students.massive_upload.validate') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="step == 3" color="primary" small @click="updes">
          {{ $t('students.massive_upload.upload') }}
        </v-btn>
        <v-btn
          v-show="step != 3"
          v-if="noButtons && step != 4"
          :disabled="flags.continue"
          color="primary"
          icon
          @click="step == 3 ? importAlways() : next()"
        >
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-card-actions>
      <!-- -------------------------------------------------------------------  -->
    </v-card>
    <ConfirmAccept
      :title="$t('students.massive_upload.step_1.confirm_modal.title')"
      :description="
        $t('students.massive_upload.step_1.confirm_modal.description')
      "
      :btn-text="$t('students.massive_upload.step_1.confirm_modal.btn')"
      @toggle="
        modals.removeMissingConfirmation = !modals.removeMissingConfirmation
      "
      :value="modals.removeMissingConfirmation"
    />
    <StudentModal
      :class="!modals.student ? 'position-no' : ''"
      :title="modals.title"
      :parent="null"
      :value="modals.value"
      :student="select.student"
      v-model="modals.student"
      @studentchange="onStudent"
      @studentchangeUp="onStudentUp"
      @cancelled="onCancel"
    ></StudentModal>
    <alert
      v-model="toast.alert"
      :title="toast.title"
      :description="toast.description"
    ></alert>
    <statusCount
      v-model="toast.status"
      :title="toast.title"
      :description="toast.description"
      :status="status"
      @updateStd="onUpdate"
      class="'position-no"
    ></statusCount>
  </v-dialog>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { mapGetters } from 'vuex'
import { funciones } from '../../Mixins/Funciones'
import alert from '../Dialogs/Alert'
import statusCount from '../Dialogs/AlertStdF'
import ConfirmAccept from '../Dialogs/ConfirmAccept.vue'
import ConfirmMail from '../Dialogs/ConfirmMails.vue'
import Notification from '../Dialogs/Notification.vue'
import StudentModal from '../Modals/StudentModalImp.vue'
import ImportParentsDetails from '../Routes/Nested_Routes/Nested_Routes/ParentDetail.vue'
export default {
  components: {
    ImportParentsDetails,
    ConfirmMail,
    StudentModal,
    alert,
    statusCount,
    Notification,
    ConfirmAccept,
  },
  props: ['value', 'mats'],
  mixins: [funciones],
  data: () => ({
    conbo: '',
    search: '',
    expand: false,

    step: 0,
    promote: false,
    removeMissing: false,
    working: {
      alt: false,
      loading: false,
      validating: false,
    },
    levels: [],
    lAbbrs: [],
    flags: {
      continue: true,
      status: 0,
    },
    modal: {
      text: 'Verificación de contenido',
      title: '',
      message: '',
    },
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    parentsMail: [],
    headers: [
      {
        text: 'Nombre',
        value: 'Nombre',
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_2.table.first_name',
      },
      {
        text: 'Apellidos',
        align: 'center',
        sortable: true,
        value: 'Apellidos',
        langKey: 'students.massive_upload.step_2.table.last_name',
      },
      {
        text: 'Género',
        value: 'gender',
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_2.table.gender',
      },
      {
        text: 'Nivel',
        value: 'level',
        align: 'center',
        langKey: 'students.massive_upload.step_2.table.level',
      },
      {
        text: 'Grado',
        align: 'center',
        sortable: true,
        value: 'grade',
        langKey: 'students.massive_upload.step_2.table.grade',
      },
      {
        text: 'Grupo',
        align: 'center',
        sortable: true,
        value: 'group',
        langKey: 'students.massive_upload.step_2.table.group',
      },
      {
        text: 'Matrícula',
        align: 'center',
        sortable: true,
        value: 'group',
        langKey: 'students.massive_upload.step_2.table.student_id',
      },
      {
        text: 'Matrícula nueva',
        align: 'center',
        sortable: true,
        value: 'group',
        langKey: 'students.massive_upload.step_2.table.new_student_id',
      },
      {
        text: 'Tutores',
        sortable: false,
        value: 'parents',
        langKey: 'students.massive_upload.step_2.table.parents',
      },
      {
        text: 'Error',
        sortable: false,
        value: 'Error',
        langKey: 'students.massive_upload.step_2.table.error',
      },
    ],
    headers1: [
      {
        text: 'Nombre',
        value: 'firstName',
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_3.table.first_name',
      },
      {
        text: 'Apellidos',
        align: 'center',
        sortable: true,
        value: 'lastName',
        langKey: 'students.massive_upload.step_3.table.last_name',
      },
      {
        text: 'Género',
        value: 'gender',
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_3.table.gender',
      },
      {
        text: 'Nivel',
        value: 'level',
        align: 'center',
        langKey: 'students.massive_upload.step_3.table.level',
      },
      {
        text: 'Grado',
        align: 'center',
        sortable: true,
        value: 'grade',
        langKey: 'students.massive_upload.step_3.table.grade',
      },
      {
        text: 'Grupo',
        align: 'center',
        sortable: true,
        value: 'group',
        langKey: 'students.massive_upload.step_3.table.group',
      },
      {
        text: 'Matrícula',
        align: 'center',
        sortable: true,
        value: 'personId',
        langKey: 'students.massive_upload.step_3.table.student_id',
      },
      {
        text: 'Tutores',
        sortable: false,
        value: 'parents',
        langKey: 'students.massive_upload.step_3.table.parents',
      },
      {
        text: 'Estatus',
        sortable: false,
        value: 'status',
        langKey: 'students.massive_upload.step_3.table.status',
      },
    ],
    modals: {
      title: '',
      student: false,
      import: false,
      importParents: false,
      removeMissingConfirmation: false,
    },
    select: {
      student: null,
    },
    toast: {
      alert: false,
      description: '',
      title: '',

      status: false,
    },
    errorItems: [],
    correctItems: [],
    parNum: 0,
    noButtons: true,
    mails: true,
    report: [],
    connected: false,
    uuid: '',
    wsStd: [],
    wsEst: [],
    progress: 0,
    progressStd: 0,
    status: {
      created: 0,
      removed: 0,
      update: 0,
      skipped: 0,
      ignored: 0,
      id: 0,
    },
    allCount: '',
    contentT: [],
    stdF: [
      { text: 'Todos', value: '' },
      { text: 'Alta', value: 'NEW' },
      { text: 'Actualización', value: 'UPGRADE' },
      { text: 'Baja', value: 'REMOVE' },
      { text: 'Sin Cambios', value: 'UNCHANGED' },
    ],
  }),
  mounted() {
    this.setLang()
    this.progress = 0
    this.status.created = 0
    this.status.removed = 0
    this.status.update = 0
    this.status.skipped = 0
    this.status.ignored = 0
    this.wsStd = []
    this.getRoomID()

    this.$store
      .dispatch('student/toolGetLevelsAndGGs')
      .then((response) => {
        for (const [index, item] of response.data.entity.entries()) {
          this.levels[item.typeLevel.toLowerCase()] = [item.id]
          this.lAbbrs[item.abbr.toLowerCase()] = [item.id]
          var ggs = []
          for (const [index2, gg] of item.ggs.entries()) {
            if (gg.grade)
              ggs[gg.grade.toLowerCase() + '' + gg.group.toLowerCase()] = gg.id
          }
          this.levels[item.typeLevel.toLowerCase()][1] = ggs
          this.lAbbrs[item.abbr.toLowerCase()][1] = ggs
        }
      })
      .catch((error) => {
        console.log(error)
      })
    this.subscribeWs()
  },
  methods: {
    setLang() {
      this.modal.text = this.$t(
        'students.massive_upload.steps.content_verification'
      )
    },
    customFilter(items, search, filter) {
      if (!search) return items
      search = search.toString().toLowerCase()
      if (search.trim() === '') return items
      const getNestedValue = (obj, path, fallback) => {
        const last = path.length - 1
        if (last < 0) return obj === undefined ? fallback : obj
        for (let i = 0; i < last; i++) {
          if (obj == null) {
            return fallback
          }
          obj = obj[path[i]]
        }
        if (obj == null) return fallback
        return obj[path[last]] === undefined ? fallback : obj[path[last]]
      }
      const getObjectValueByPath = (obj, path, fallback) => {
        // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
        if (obj == null || !path || typeof path !== 'string') return fallback
        if (obj[path] !== undefined) return obj[path]
        path = path.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
        path = path.replace(/^\./, '') // strip a leading dot
        return getNestedValue(obj, path.split('.'), fallback)
      }

      return items.filter(({ status, ...item }) =>
        Object.keys(item).some((key) =>
          filter(getObjectValueByPath(item, key), search, item)
        )
      )
    },

    onChangeRemoveMissing() {
      if (this.removeMissing) {
        this.modals.removeMissingConfirmation = true
      }
    },
    onCancel() {
      this.modals.importParents = false
      this.QRSizeModal.value = false
      this.modals.student = false
      this.modals.import = false
      this.modals.notify = false
      this.$forceUpdate()
    },
    updateStudent(event) {
      var i = this.students.indexOf(this.select.student)
      this.contentT[i].firstName = event.firstName
      this.contentT[i].lastName = event.lastName
      this.contentT[i].gender = event.gender
      this.contentT[i].grade = event.grade
      this.contentT[i].level = event.level
      this.contentT[i].personId = event.personId
      this.contentT[i].updatedPersonId = event.updatedPersonId
      this.select.student = null
      this.selected = []
      this.toast.success = true
    },
    onUpdate() {
      var request = {
        sendFlag: this.mails,
        idStudentUpgrade: this.status.id,
      }
      this.step = 4
      this.$store
        .dispatch('student/addStudentWithParentsNextStep', request)
        .then((response) => {
          console.log(response)
          this.flags.status = 201
          this.modal.title = 'Error de importación'
          this.modal.message =
            'El proceso de importación no se ha podido completar, por favor intenta nuevamente.'
          this.working.alt = true
          this.beforeDestroy1()
        })
        .catch((error) => {
          if (error && error.status && error.status === 409) {
            this.toast.title = '¡Atención!'
            this.toast.description =
              'Actualmente se está realizando otra carga masiva de alumnos y tutores en tu colegio, por favor espera que el proceso termine para poder continuar.'
            this.toast.alert = true
          } else {
            this.progressStd = 100
            this.flags.status = 200
            this.modal.title = this.$t(
              'students.massive_upload.step_4.import_completed'
            )
            this.modal.message = this.$t(
              'students.massive_upload.step_4.import_success'
            )
            this.working.alt = true
            this.beforeDestroy1()
          }
        })
    },
    updes() {
      this.mailConfirm()
      /* if (
        this.status.created == this.allCount &&
        this.status.removed == 0 &&
        this.status.update == 0
      ) {
      } else {
        this.toast.status = true;
      } */
    },
    onCancel() {
      this.modals.alert = false
      this.$forceUpdate()
    },
    onStudent(val) {
      this.errorItems[val.pos].Nombre = val.firstName
      this.errorItems[val.pos].Apellidos = val.lastName
      this.errorItems[val.pos].Genero = val.gender
      this.errorItems[val.pos].Nivel = val.level.typeLevel
      this.errorItems[val.pos].Grado = val.gg.grade
      this.errorItems[val.pos].Grupo = val.gg.group
      this.errorItems[val.pos].Matricula = val.personId
      this.errorItems[val.pos].Matricula_Nueva = val.updatedPersonId

      this.$forceUpdate()
    },
    onStudentUp(event) {
      const vari = this.contentT.indexOf(this.select.student)
      event.parents = this.contentT[vari].parents
      if (this.select.student.status == 'UNCHANGED') {
        this.status.update = this.status.update + 1
        this.status.ignored = this.status.ignored - 1
      }
      this.contentT.splice(this.contentT.indexOf(this.select.student), 1)
      this.contentT.push(event)
      this.select.student = null
      this.selected = []
      this.modals.student = false
      this.$forceUpdate()
    },
    onTest1(val) {
      this.errorItems[val.posS].parents[val.pos].firstName = val.firstName
      this.errorItems[val.posS].parents[val.pos].lastName = val.lastName
      this.errorItems[val.posS].parents[val.pos].mail = val.mail
      this.$forceUpdate()
    },
    parentUp(event) {},
    editStudent(student) {
      this.select.student = student
      this.modals.student = true
      this.modals.title = this.$t(
        'students.massive_upload.step_3.table.edit_modal.edit_data'
      )
    },
    fileLoad(event) {
      this.working.loading = true
      this.processFile(
        event.target.files,
        event.target.value,
        'tutores-alumnos',
        {
          levels: this.levels,
          mats: this.mats,
          abbrs: this.lAbbrs,
        }
      )
        .then((result) => {
          if (result == 200 || result == 201) {
            this.flags.status = result
            this.flags.continue = false
          }
        })
        .catch((err) => {
          if (this.excel2jsonFail.length < 15 && err != 403) {
            this.flags.status = 201
            this.flags.continue = false
          } else {
            this.flags.status = err
            this.flags.continue = true
          }
        })
        .finally(() => {
          this.working.loading = false
          console.log()
        })
    },
    makeid(length) {
      var result = ''
      var characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var charactersLength = characters.length
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        )
      }
      return result
    },
    next() {
      switch (this.step) {
        case 1:
          // this.step = 2;
          if (this.excel2jsonFail.length > 0) {
            this.step = 2
            // forFails:
            for (let a of this.excel2jsonFail) {
              a.id = this.makeid(10)
              a.parents = []
              // var parentsA = [];
              // var par = {};
              // a.parents = [];
              // var parNum = 1;
              // var keys = Object.keys(a);
              // parFor:
              for (let i = 1; i <= this.parNum; i++) {
                if (
                  !(a['Nombre_Tutor' + i] === undefined) ||
                  !(a['Apellido_Tutor' + i] === undefined) ||
                  !(a['Correo_Tutor' + i] === undefined)
                ) {
                  a.parents.push({
                    firstName: a['Nombre_Tutor' + i],
                    lastName: a['Apellido_Tutor' + i],
                    mail: a['Correo_Tutor' + i],
                  })
                }
                // else {
                //   continue parFor;
                // }
              }
            }
            // forFails:
            for (let a of this.excel2json) {
              a.id = this.makeid(10)
              a.parents = []
              // var parentsA = [];
              // var par = {};
              // var parNum = 1;
              // var keys = Object.keys(a);
              // parFor:
              for (let i = 1; i <= this.parNum; i++) {
                if (
                  !(a['Nombre_Tutor' + i] === undefined) ||
                  !(a['Apellido_Tutor' + i] === undefined) ||
                  !(a['Correo_Tutor' + i] === undefined)
                ) {
                  a.parents.push({
                    firstName: a['Nombre_Tutor' + i],
                    lastName: a['Apellido_Tutor' + i],
                    mail: a['Correo_Tutor' + i],
                  })
                }
                // else {
                //   a.parents.push(null);
                // }
              }
            }
            for (let index = 0; index < this.excel2jsonFail.length; index++) {
              this.excel2jsonFail[index].pos = index
              for (
                let a = 0;
                a < this.excel2jsonFail[index].parents.length;
                a++
              ) {
                this.excel2jsonFail[index].parents[a].pos = a
                this.excel2jsonFail[index].parents[a].posS = index
              }
            }
            this.errorItems = this.excel2jsonFail
            this.modal.text = 'Errores encontrados'
            this.toast.title = 'Aviso'
            this.toast.description =
              'Se han encontrado uno o más errores en el archivo que deseas importar, para continuar con el proceso, asegúrate de corregirlos'
            this.toast.alert = true
          } else {
            // forFails:
            for (let a of this.excel2json) {
              a.id = this.makeid(10)
              a.parents = []
              // var parentsA = [];
              // var par = {};
              // var parNum = 1;
              // var keys = Object.keys(a);
              // parFor:
              for (let i = 1; i <= this.parNum; i++) {
                if (
                  !(a['Nombre_Tutor' + i] === undefined) ||
                  !(a['Apellido_Tutor' + i] === undefined) ||
                  !(a['Correo_Tutor' + i] === undefined)
                ) {
                  a.parents.push({
                    firstName: a['Nombre_Tutor' + i],
                    lastName: a['Apellido_Tutor' + i],
                    mail: a['Correo_Tutor' + i],
                  })
                }
                // else {
                //   continue parFor;
                // }
              }
            }
            this.errorItems = this.excel2json
            this.modal.text = this.$t('students.massive_upload.steps.detail')
            this.isLocked()
              .then(() => {
                this.step = 3
              })
              .then(this.import)
          }
          this.$forceUpdate()
          break
        case 2:
          this.working.validating = true
          var v = this
          var p = new Promise((resolve, reject) => {
            for (var i in v.errorItems) {
              if (v.errorItems[i].Error != null) {
                v.excel2json.push(v.errorItems[i])
              }
            }
            v.validateExcelStdsPars(resolve, reject, {
              levels: this.levels,
              mats: this.mats,
              abbrs: this.lAbbrs,
            })
          })
            .then((result) => {
              v.working.validating = false
              if (result == 201) {
                v.modal.text = 'Errores encontrados'
                v.errorItems = v.excel2jsonFail
                for (
                  let index = 0;
                  index < this.excel2jsonFail.length;
                  index++
                ) {
                  this.excel2jsonFail[index].pos = index
                  for (
                    let a = 0;
                    a < this.excel2jsonFail[index].parents.length;
                    a++
                  ) {
                    this.excel2jsonFail[index].parents[a].pos = a
                    this.excel2jsonFail[index].parents[a].posS = index
                  }
                }
              } else {
                v.modal.text = this.$t(
                  'students.massive_upload.steps.content_verification'
                )
                v.errorItems = v.excel2json
                this.step = 3
                v.$forceUpdate()
                this.import()
              }
              v.flags.status = result
              v.$forceUpdate()
            })
            .catch((err) => {
              this.toast.title = 'Datos incompletos'
              this.toast.description =
                'Se han detectado algunos campos vacíos, por favor asegúrate de completar los datos'
              this.toast.alert = true
              v.working.validating = false
              console.log(err)
            })
          break
        //////////////
        case 3:
          break
      }
    },
    importAlways() {
      this.import()
      this.working.validating = true
    },
    isLocked() {
      return this.$store
        .dispatch('student/isLocked')
        .then((res) => {
          if (res.data === true) {
            this.toast.title = '¡Atención!'
            this.toast.description =
              'Actualmente se está realizando la carga masiva de alumnos y tutores en tu colegio, por favor espera que el proceso termine para poder continuar.'
            this.toast.alert = true
            return Promise.reject('isLocked')
          } else {
            return res.data
          }
        })
        .catch((err) => {
          this.toast.title = 'Aviso'
          this.toast.description =
            'El proceso de importación no se ha podido completar, por favor intenta nuevamente.'
          this.toast.alert = true
          return false
        })
    },
    import() {
      var emailReg =
        /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])$/i
      var temp = [...this.excel2json]

      for (let index = 0; index < this.errorItems.length; index++) {
        if (this.errorItems[index].pos) {
          delete this.errorItems[index].pos
        }

        for (let a = 0; a < this.errorItems[index].parents.length; a++) {
          if (this.errorItems[index].parents[a] != null) {
            delete this.errorItems[index].parents[a].pos
            delete this.errorItems[index].parents[a].posS
          }
        }
      }

      for (let i in this.errorItems) {
        if (this.errorItems[i].Error != null) temp.push(this.errorItems[i])
      }

      this.noButtons = false
      // var flag = 0;
      var allStds = []
      for (var c in temp) {
        var student = {
          firstName: temp[c].Nombre,
          lastName: temp[c].Apellidos,
          gender: temp[c].Genero,
          level: temp[c].level,
          gg: temp[c].gg,
          personId: temp[c].Matricula,
          updatedPersonId: temp[c].Matricula_Nueva,
          parents: [],
        }
        for (const [index, item] of temp[c].parents.entries()) {
          if (item && !emailReg.test(item.mail)) {
            continue
          }
          if (item != null) {
            student.parents.push(item)
          }
        }
        if (!student.parents || student.parents.length === 0) {
        }
        // aqui tienes la lista de objetos en Json

        allStds.push(student)
      }

      var request = {
        promote: this.promote,
        students: allStds,
        socket: this.uuid,
        removeMissing: this.removeMissing,
      }

      return this.$store
        .dispatch('student/addStudentWithParents', request)
        .then((response) => {
          this.subscribeWs()
          this.$emit('imported', '')
          this.report = response.data.entity
          this.flags.status = 200
          this.modal.title = 'Error de importación'
          this.modal.message =
            'El proceso de importación no se ha podido completar, por favor intenta nuevamente.'
          this.working.validating = false
          this.step = 3
          for (var r of this.report) {
            if (r.code != 200) {
              this.flags.status = 201
              this.modal.title = 'Advertencia'
              this.modal.message =
                'Algunos archivos no se pudieron importar, descarga el archivo para verificar los registros'
            }
          }
          this.noButtons = true
        })
        .catch((error) => {
          this.step = 3
          this.progress = 100
          this.status.created = error.data.created
          this.status.removed = error.data.removed
          this.status.update = error.data.updated
          this.status.skipped = error.data.skipped
          this.status.ignored = error.data.ignored
          this.status.id = error.data.id
          this.allCount =
            error.data.created +
            error.data.removed +
            error.data.updated +
            error.data.skipped +
            error.data.ignored
          this.$emit('imported', '')
          this.working.validating = false
          this.$forceUpdate()
          this.noButtons = true
          this.subscribeWs1()
          this.toast.title = this.$t(
            'students.massive_upload.step_3.modal.title'
          )
          this.toast.description = this.$t(
            'students.massive_upload.step_3.modal.description'
          )
          this.toast.alert = true
        })
    },

    getRoomID() {
      this.uuid = uuidv4()
    },

    subscribeWs() {
      if (this.uuid) {
        var room = this.uuid + '-upgrade-step2'
        console.log('Connecting & subscribing to ', room)
        this.$socket.connect()
        this.$socket.emit('subscribe', room)
        this.connected = true
      } else {
        console.log('No branch yet')
      }
    },

    beforeDestroy() {
      var room = this.uuid + '-upgrade-step2'
      console.log('Unsubscribe from', room)
      this.$socket.emit('unsubscribe', room)
    },

    subscribeWs1() {
      if (this.status.id) {
        var room = this.status.id + '-upgrade-step3'
        console.log('Connecting & subscribing to ', room)
        this.$socket.connect()
        this.$socket.emit('subscribe', room)
        this.connected = true
      } else {
        console.log('No branch yet')
      }
    },

    beforeDestroy1() {
      var room = this.status.id + '-upgrade-step3'
      console.log('Unsubscribe from', room)
      this.$socket.emit('unsubscribe', room)
    },

    download() {
      var content = []
      console.log(this.report)
      for (const [index, item] of this.report.entries()) {
        var register = {}
        register['Nombre-estudiante'] = item.entity.firstName
        register['Apellidos-estudiante'] = item.entity.lastName
        register['Matrícula'] = item.entity.personId
        register['Nivel'] = item.entity.level.typeLevel
        register['Grado'] = item.entity.gg.grade
        register['Grupo'] = item.entity.gg.group
        for (const [i, it] of item.entity.parents.entries()) {
          register['Nombre-Tutor' + (i + 1)] = it.firstName
          register['Apellidos-Tutor' + (i + 1)] = it.lastName
          register['Email-Tutor' + (i + 1)] = it.mail
        }
        register['Estado'] = item.message
        content.push(register)
      }

      this.downloadReport(content)
    },
    back() {
      switch (this.step) {
        case 2:
          this.step = 1
          this.errorItems = []
          this.$forceUpdate()
          break
      }
    },
    close() {
      this.$emit('input', false)
      this.$emit('onClosed', false)
      this.$emit('getStudents')
      this.step = 1
      this.excel2json = []
      this.noButtons = true
      this.excel2jsonFail = []
      this.badlist = false
      this.errorCode = 0
      this.flags.continue = true
      this.flags.status = 0
      this.expand = false
      this.promote = false
      this.removeMissing = false
      this.wsStd = []
      this.wsEst = []
      this.contentT = []
      this.errorItems = []
      this.progress = 0
      this.progressStd = 0
      this.status.created = 0
      this.status.removed = 0
      this.status.update = 0
      this.status.skipped = 0
      this.status.ignored = 0
      this.status.id = 0
      this.conbo = ''
      this.modals = {
        title: '',
        student: false,
        import: false,
        importParents: false,
        removeMissingConfirmation: false,
      }
      this.modal = {
        text: this.$t('students.massive_upload.steps.content_verification'),
        title: '',
        message: '',
      }
      this.working = {
        alt: false,
        loading: false,
        validating: false,
      }

      document.getElementById('file_csv_colab').value = ''
    },
    mailConfirm() {
      this.confirm.description = this.$t(
        'students.massive_upload.step_3.modal_email_confirm.description'
      )
      this.confirm.value = true
      this.confirm.title = this.$t(
        'students.massive_upload.step_3.modal_email_confirm.title'
      )
      this.confirm.show = true
    },
    desitionLink(val) {
      this.confirm.value = false
      this.confirm.show = false
      this.mails = val
      if (
        this.status.created == this.allCount &&
        this.status.removed == 0 &&
        this.status.update == 0
      ) {
        this.onUpdate()
      } else {
        this.toast.status = true
      }
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.close()
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },

  sockets: {
    connect(evt) {
      console.log('Connected', evt)
    },
    disconnect(evt) {
      console.log('Disconnected', evt)
    },
    reconnect() {
      console.log('Reconnected')
      this.subscribeWs()
    },
    message(notification) {
      ;(notification.parents || []).forEach((parent) => {
        parent.stdId = notification.id
      })
      if (this.step == 3) {
        this.contentT.push(notification)
        if (this.progress < 100) {
          this.progress = (this.contentT.length / this.excel2json.length) * 100
        }
      }
      if (this.step == 4) {
        this.wsEst.push(notification)
        if (this.progressStd < 100) {
          this.progressStd = (this.wsEst.length / this.excel2json.length) * 100
        }
      }
    },
  },
  watch: {
    getLang() {
      this.setLang()
    },
  },
  computed: {
    filteredItemsByStatus() {
      return this.contentT.filter((i) => {
        return !this.conbo || i.status === this.conbo
      })
    },
    ...mapGetters(['getUser', 'getBranch', 'getLang']),
  },
}
</script>

<style>
.form-csv input {
  position: absolute;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 190px;
  outline: none;
  opacity: 0;
}

.csv-text {
  margin-top: 10%;
}

.form-csv {
  height: 200px;
  border: 4px dashed #c6c7c7;
  background-color: #eceff0;
}
</style>
<style scoped>
td,
th {
  width: 110px;
  max-width: 110px;
  min-width: 110px;
}

.bar {
  background: linear-gradient(to right, #ef565b, #512e6f);
  height: 20px;
  width: 20px;
  border-radius: 9px;
}
.spb {
  padding: 4px 5px;
  color: #fff;
  font-size: 0.7em;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
</style>
